import { render, staticRenderFns } from "./MDchannel.vue?vue&type=template&id=6f6d02da"
import script from "./MDchannel.vue?vue&type=script&lang=js"
export * from "./MDchannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports